<template>
  <div>  
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
  
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12"
              sm="9"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs" 
                    v-on="on" 
                    @click="regresar"
                  >
                    <v-icon>
                      mdi-arrow-left
                    </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>

              Expertos Regionales: {{ habilidadCompetencia.categoria }}
            </v-col>

            <v-col 
              cols="12"
              sm="3"
              class="d-flex justify-end"
            >
              <template v-if="competenciaWorldskills.tipo_competencia_id != 3">
                <v-btn
                  exact
                  color="primary"
                  class="mr-4"
                  @click="adjudicarExpertos"
                >
                  Adjudicar
                </v-btn> 
              </template> 

              <v-btn
                exact
                color="primary"
                @click="open"
              >
                Registrar
              </v-btn>
            </v-col>

            <v-col 
              cols="12"
              sm="3"
              offset-sm="9"
            >
              <v-text-field
                outlined
                dense
                append-icon="mdi-magnify"
                label="Buscar Experto"
                hide-details
                v-model="searchTable"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 280px)"
          class="elevation-2"
          :headers="headersTable"
          :items="expertosRegionalesWorldSkillsNacional"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        > 
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs" 
                  v-on="on"
                  @click="detalles(item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs" 
                  v-on="on"
                  @click="editar(item.id)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }" >
                <v-icon
                  color="error"
                  v-bind="attrs" 
                  v-on="on"
                  @click="activarAlertaEliminar(item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>

          <template v-slot:top>
            <v-dialog 
              persistent
              v-model="dialogForm" 
              max-width="520px"
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">{{ formTitle }}</p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col 
                        cols="12"
                        md="10"
                      >
                        <v-form 
                          ref="form" 
                          v-model="form"
                        >
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Habilidad"
                            v-model="habilidadSeleccionada"
                          >
                          </v-text-field>

                          <v-select
                            outlined
                            dense
                            label="Regional*"
                            :items="regionales"
                            item-value="id"
                            item-text="regional"
                            v-model="regional"
                            :rules="regionalReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Centro de Formación*"
                            :items="centrosFormacionNacional"
                            item-value="id"
                            item-text="centro_formacion"
                            v-model="centroFormacion"
                            :rules="centroFormacionReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Tipo de Identificación*"
                            :items="tiposIdentificacion"
                            item-value="id"
                            item-text="tipo_identificacion"
                            v-model="tipoIdentificacion"
                            :rules="tipoIdentificacionReglas"
                          >
                          </v-select>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Número de Identificación*"
                            min="1"
                            maxlength="10"
                            counter
                            v-model="identificacion"
                            :rules="identificacionReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Nombres*"
                            maxlength="50"
                            counter
                            v-model.trim="nombres"
                            :rules="nombresReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Apellidos*"
                            maxlength="50"
                            counter
                            v-model.trim="apellidos"
                            :rules="apellidosReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Correo Electronico*"
                            maxlength="50"
                            counter
                            v-model.trim="correo"
                            :rules="correoReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Telefono Movil*"
                            min="1"
                            maxlength="10"
                            counter
                            v-model="telefonoMovil"
                            :rules="telefonoMovilReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Direccion*"
                            maxlength="50"
                            counter
                            v-model.trim="direccion"
                            :rules="direccionReglas"
                          >
                          </v-text-field>

                          <v-dialog 
                            ref="fechaNacimiento" 
                            persistent
                            width="300px"
                            v-model="dialogFechaNacimiento" 
                            :return-value.sync="fechaNacimiento"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field 
                                outlined 
                                dense 
                                readonly
                                prepend-inner-icon="mdi-calendar" 
                                label="Fecha de Nacimiento*" 
                                v-model="fechaNacimiento" 
                                :rules="fechaNacimientoReglas" 
                                v-bind="attrs" 
                                v-on="on"
                              >
                              </v-text-field>
                            </template>

                            <v-date-picker 
                              scrollable 
                              color="primary"
                              v-model="fechaNacimiento"
                            >
                              <v-spacer></v-spacer>
                              <v-btn 
                                text 
                                color="error" 
                                @click="dialogFechaNacimiento = false"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn 
                                text 
                                color="primary" 
                                @click="$refs.fechaNacimiento.save(fechaNacimiento)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>

                          <v-select
                            outlined
                            dense
                            label="Genero*"
                            :items="generos"
                            item-value="id"
                            item-text="genero"
                            v-model="genero"
                            :rules="generoReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Estado Civil*"
                            :items="estadosCiviles"
                            item-value="id"
                            item-text="estado_civil"
                            v-model="estadoCivil"
                            :rules="estadoCivilReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Estrato*"
                            :items="estratos"
                            item-value="id"
                            item-text="estrato"
                            v-model="estrato"
                            :rules="estratoReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Zona*"
                            :items="zonas"
                            item-value="id"
                            item-text="zona"
                            v-model="zona"
                            :rules="zonaReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Discapacidad*"
                            :items="discapacidades"
                            item-value="id"
                            item-text="discapacidad"
                            v-model="discapacidad"
                            :rules="discapacidadReglas"
                          >
                          </v-select>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Cargo*"
                            maxlength="50"
                            counter
                            v-model.trim="cargo"
                            :rules="cargoReglas"
                          >
                          </v-text-field>

                          <v-select
                            outlined
                            dense
                            label="Talla de Camiseta*"
                            :items="tallas"
                            v-model="talla"
                            :rules="tallaReglas"
                          >
                          </v-select>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="error" 
                    @click="close"
                  >
                    Cancelar
                  </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn text exact color="primary" @click="registrar">
                      Registrar
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn text exact color="primary" @click="actualizar">
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog 
              v-model="dialogDelete" 
              max-width="480px"
            >
              <v-card>
                <v-card-title class="justify-center text-h5">¿Desea eliminar el experto regional?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="primary" 
                    @click="closeDelete"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn 
                    text 
                    color="error" 
                    @click="eliminar"
                  > 
                    OK
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card>
    </template> 
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue';

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Identificacion",
        value: "identificacion",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Nombres",
        value: "nombres",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Apellidos",
        value: "apellidos",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Regional",
        value: "regional",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Centro de Formación",
        value: "centro_formacion",
        align: "start",
        width: "20%",
        class: ["text-subtitle-1", "font-weight-black"]
      },
      
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"]
      }
    ],

    form: true,
    loadingForm: false,

    dialogForm: false,
    dialogDelete: false,
    temCupo_id: null,

    competenciaSeleccionada: "",
    habilidadSeleccionada: "",

    regionalUsuario: null,

    regional: null,
    regionalReglas: [
      (v) => !!v || "Seleccione una regional"
    ],

    centroFormacion: null,
    centroFormacionReglas: [
      (v) => !!v || "Seleccione un centro de formación"
    ],

    tipoIdentificacion: null,
    tipoIdentificacionReglas: [
      (v) => !!v || "Seleccione un tipo de Identififcacion",
    ],
    tiposIdentificacion: [
      { tipo_identificacion: "Tarjeta de Identidad", id: 1 },
      { tipo_identificacion: "Cedula de Ciudadania", id: 2 },
      { tipo_identificacion: "Documento Extranjero", id: 3 }
    ],

    identificacion: null,
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
      (v) => (v && v.length >= 6) || "Minimo 6 digitos",
    ],
    mensajeIdentificacion: "",

    nombres: null,
    nombresReglas: [(v) => !!v || "Escriba los nombres"],

    apellidos: null,
    apellidosReglas: [(v) => !!v || "Escriba los apellidos"],

    correo: null,
    correoReglas: [
      (v) => !!v || "Escriba un correo electrónico",
      (v) => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ],

    telefonoMovil: null,
    telefonoMovilReglas: [
      (v) => !!v || "Escriba un número de telefono movil",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos"
    ],

    direccion: null,
    direccionReglas: [(v) => !!v || "Escriba una dirección"],

    dialogFechaNacimiento: false,
    fechaNacimiento: null,
    fechaNacimientoReglas: [(v) => !!v || "Seleccione una fecha"],

    genero: null,
    generoReglas: [
      (v) => (!!v) || "Seleccione un genero",
    ],
    generos: [
      { genero: "Femenino", id: 1 },
      { genero: "Masculino", id: 2 },
    ],

    estadoCivil: null,
    estadoCivilReglas: [(v) => !!v || "Seleccione un estado civil"],
    estadosCiviles: [
      { estado_civil: "Viudo", id: 1 },
      { estado_civil: "Separado", id: 2 },
      { estado_civil: "Unión Libre", id: 3 },
      { estado_civil: "Casado", id: 4 },
      { estado_civil: "Soltero", id: 5 },
      { estado_civil: "Indiferente", id: 6 }
    ],

    estrato: null,
    estratoReglas: [(v) => !!v || "Seleccione un estrato"],
    estratos: [
      { estrato: 1, id: 1 },
      { estrato: 2, id: 2 },
      { estrato: 3, id: 3 },
      { estrato: 4, id: 4 },
      { estrato: 5, id: 5 },
      { estrato: 6, id: 6 },
    ],

    zona: null,
    zonaReglas: [(v) => !!v || "Seleccione una zona"],
    zonas: [
      { zona: "Urbana", id: 1 },
      { zona: "Rural", id: 2 },
    ],

    discapacidad: null,
    discapacidadReglas: [(v) => !!v || "Seleccione una discapacidad"],
    discapacidades: [
      { discapacidad: "Ninguna", id: 1 },
      { discapacidad: "Cognitiva", id: 2 },
      { discapacidad: "Fisica", id: 3 },
    ],

    cargo: null,
    cargoReglas: [
      (v) => !!v || "Escriba un cargo"
    ],

    talla: null,
    tallas: ["XS", "S", "M", "L", "XL", "XXL"],
    tallaReglas: [
      (v) => !!v || "Seleccione una talla"
    ],

    idExpertoWS: null,
    idPersona: null,

    editedIndex: -1
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("crearRegionales")
    this.$store.dispatch("crearCentrosFormacion")

    this.$store.dispatch("gestionarExpertosRegionales", this.$route.params.id_competencia)
    this.$store.dispatch("detalleCompetenciaWorldSkills", this.$route.params.id_competencia)
    this.$store.dispatch("gestionarHabilidadesCompetencia", this.$route.params.id_competencia)
    
    setTimeout(() => {
      this.skeletonLoader = false
    }, 2000)
  },

  computed: {
    usuario() {
      return this.$store.getters.usuario;
    },

    centroFormacionUsuario() {
      return this.$store.getters.obtenerCentroFormacion(this.usuario.centro_formacion_id)
    },

    expertosRegionalesWorldSkillsRegional() {
      const expertosRegionalesWorldSkills = this.$store.getters.obtenerExpertosRegionalesWorldSkills(this.$route.params.id_competencia, this.$route.params.id_categoria)
      const expertosRegionales =  expertosRegionalesWorldSkills.filter(experto => experto.regional_id == this.centroFormacionUsuario.regional_id)
      return expertosRegionales
    },

    expertosRegionalesWorldSkillsNacional() {
      return this.$store.getters.obtenerExpertosRegionalesWorldSkills(this.$route.params.id_competencia, this.$route.params.id_categoria)
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Registrar Experto Regional' : 'Actualizar Experto Regional'
    },

    habilidadCompetencia() {
      return this.$store.getters.obtenerHabilidadCompetenciaWorldSkills(this.$route.params.id_competencia, this.$route.params.id_categoria);
    },

    competenciaWorldskills() {
      return this.$store.getters.obtenerCompetenciaWorldSkills
    },

    regionales() {
      return this.$store.getters.obtenerRegionales
    },

    centrosFormacionRegional() {
      return this.$store.getters.obtenerCentrosFormacion(this.centroFormacionUsuario.regional_id)
    },

    centrosFormacionNacional() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional)
    }
  },

  watch: {
    dialogForm(val) {
      val || this.close()
    },

    dialogDelete(val) {
      val || this.closeDelete()
    }
  },

  methods: {
    open() {
      this.dialogForm = true
      this.competenciaSeleccionada = this.habilidadCompetencia.competencia
      this.habilidadSeleccionada = this.habilidadCompetencia.categoria
      this.regionalUsuario = this.centroFormacionUsuario.regional;
    },

    deleteItemConfirm() {
      this.dialogDelete = false
    },

    close() {
      this.dialogForm = false
      this.editedIndex = -1
      this.$refs.form.reset();
    },

    closeDelete () {
      this.dialogDelete = false
      this.editedIndex = -1
    },

    registrar() {
      if(this.$refs.form.validate()) {
        const nombresPersona = this.nombres.split(" ")
        const apellidosPersona = this.apellidos.split(" ")

        const expertoRegional = {
          competencia_id:         this.$route.params.id_competencia,
          categoria_id:           this.$route.params.id_categoria,
          centro_formacion_id:    this.centroFormacion,
          tipo_lider_id:          6,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion:         this.identificacion,
          primer_nombre:          nombresPersona[0],
          segundo_nombre:         nombresPersona[1],
          primer_apellido:        apellidosPersona[0],
          segundo_apellido:       apellidosPersona[1],
          correo:                 this.correo,
          telefono_movil:         this.telefonoMovil,
          direccion:              this.direccion,
          fecha_nacimiento:       this.fechaNacimiento,
          genero_id:              this.genero,
          estado_civil_id:        this.estadoCivil,
          estrato:                this.estrato,
          zona_id:                this.zona,
          discapacidad_id:        this.discapacidad,
          cargo:                  this.cargo,
          talla_camiseta:         this.talla,
        }
        this.loadingForm = true

        this.$store.dispatch("registrarExpertoRegional", expertoRegional)
        .then((response) => {
          if(response.status == "success") {
            this.loadingForm = false;
            this.close()
            
            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true
            
            this.$store.dispatch("gestionarExpertosRegionales", this.$route.params.id_competencia)
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false
            }, 1000)
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});  
      }
    },

    detalles(idExperto) {
      this.$router.push({
        name: "expertows-detalles",
        params: { id_experto: idExperto } 
      });
    },

    editar(idExperto) {
      this.editedIndex = 1;
      this.disabledForm = true
      const expertoRegionalWorldskills = this.$store.getters.obtenerExpertoRegionalWorldSkills(idExperto);
      this.idExpertoWS              = idExperto
      this.competenciaSeleccionada  = this.habilidadCompetencia.competencia
      this.habilidadSeleccionada    = this.habilidadCompetencia.categoria
      this.regionalUsuario          = this.centroFormacionUsuario.regional
      this.regional                 = expertoRegionalWorldskills.regional_id
      this.centroFormacion          = expertoRegionalWorldskills.centro_formacion_id
      this.idPersona                = expertoRegionalWorldskills.persona_id;
      this.tipoIdentificacion       = expertoRegionalWorldskills.tipo_identificacion_id;
      this.identificacion           = expertoRegionalWorldskills.identificacion;
      this.nombres                  = expertoRegionalWorldskills.nombres;
      this.apellidos                = expertoRegionalWorldskills.apellidos;
      this.correo                   = expertoRegionalWorldskills.correo;
      this.telefonoMovil            = expertoRegionalWorldskills.telefono_movil;
      this.direccion                = expertoRegionalWorldskills.direccion;
      this.fechaNacimiento          = expertoRegionalWorldskills.fecha_nacimiento;
      this.genero                   = expertoRegionalWorldskills.genero_id;
      this.estadoCivil              = expertoRegionalWorldskills.estado_civil_id;
      this.estrato                  = expertoRegionalWorldskills.estrato;
      this.zona                     = expertoRegionalWorldskills.zona_id;
      this.discapacidad             = expertoRegionalWorldskills.discapacidad_id;
      this.cargo                    = expertoRegionalWorldskills.cargo;
      this.talla                    = expertoRegionalWorldskills.talla_camiseta;

      this.validarPersona = true
      this.dialogForm = true;
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.trim().split(" ")
        const apellidosPersona = this.apellidos.trim().split(" ")

        const expertoRegional = {
          id:                     this.idExpertoWS,
          competencia_id:         this.$route.params.id_competencia,
          categoria_id:           this.$route.params.id_categoria,
          centro_formacion_id:    this.centroFormacion,
          tipo_lider_id:          6,
          persona_id:             this.idPersona,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion:         this.identificacion,
          primer_nombre:          nombresPersona[0],
          segundo_nombre:         nombresPersona[1],
          primer_apellido:        apellidosPersona[0],
          segundo_apellido:       apellidosPersona[1],
          correo:                 this.correo,
          telefono_movil:         this.telefonoMovil,
          direccion:              this.direccion,
          fecha_nacimiento:       this.fechaNacimiento,
          genero_id:              this.genero,
          estado_civil_id:        this.estadoCivil,
          estrato:                this.estrato,
          zona_id:                this.zona,
          discapacidad_id:        this.discapacidad,
          cargo:                  this.cargo,
          talla_camiseta:         this.talla,
        }

        this.loadingForm = true;
        this.$store.dispatch("actualizarExpertoRegional", expertoRegional)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm = false;
            this.close()

            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true; 

            this.skeletonLoader  = true
            
            this.$store.dispatch("gestionarExpertosRegionales", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false
            }, 1000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    activarAlertaEliminar(idexperto) {
      this.idExpertoWS = idexperto
      this.dialogDelete = true
    },

    eliminar() {
      this.dialogDelete = false
      this.$store.dispatch("eliminarExpertoRegional", this.idExpertoWS)
      .then((response) => {
        if(response.status == "success") {
          let message       = response.message.split(',')
          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true; 

          this.skeletonLoader  = true
          
          this.$store.dispatch("gestionarExpertosRegionales", this.$route.params.id_competencia)
          setTimeout(() => {
            this.alert = false;
            this.skeletonLoader = false
          }, 1000)     
        } 
        else {
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }

          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    adjudicarExpertos() {
      const competencia = {
        competencia_id: this.$route.params.id_competencia,
        categoria_id:   this.$route.params.id_categoria
      };

      this.$store.dispatch("adjudicarExpertosRegionalesWorldskills", competencia)
      .then((response) => {
        if (response.status == "success") {
          let message       = response.message.split(',')
          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;
          
          this.skeletonLoader = true
        
          this.$store.dispatch("gestionarExpertosRegionales", this.$route.params.id_competencia)
          setTimeout(() => {
            this.alert = false;
            this.skeletonLoader = false
          }, 1000)
        } 
        else {
          this.loadingForm  = false
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }

          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    regresar() {
      this.$router.back()
    },
  }
};
</script>
